import { Component, input, output } from '@angular/core';
import { Toast } from '../../state/toast/toast.service.interface';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
})
export class ToastComponent {
  public toast = input<Toast>();
  public dismissToast = output<void>();

  protected closeToast() {
    this.dismissToast.emit();
  }
}
